var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarRepair128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 56.8066H111.086C116.561 56.8066 120.999 61.2448 120.999 66.7196V84.0672H16.9129C11.4382 84.0672 7 79.629 7 74.1543V56.8066Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1278 82.8288C44.1278 88.9883 39.1344 93.9809 32.9768 93.9809C26.8171 93.9809 21.8237 88.9883 21.8237 82.8288C21.8237 76.6694 26.8171 71.6768 32.9768 71.6768C39.1344 71.6768 44.1278 76.6694 44.1278 82.8288Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.561 82.8288C108.561 88.9883 103.568 93.9809 97.4099 93.9809C91.2502 93.9809 86.2568 88.9883 86.2568 82.8288C86.2568 76.6694 91.2502 71.6768 97.4099 71.6768C103.568 71.6768 108.561 76.6694 108.561 82.8288Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2269 38.4391C39.8695 36.2652 43.4314 34.5029 46.1724 34.5029H69.4362C72.1818 34.5029 75.7582 36.2905 77.3817 38.4391L91.2604 56.807H24.3481L38.2269 38.4391Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2607 56.8066L105.78 42.2874C107.342 40.7253 109.875 40.7253 111.437 42.2874L113.565 44.4154",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarRepair128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarRepair128.7101005c4e47dd5cccfc2b38093b1249.svg";
export { ForwardRef as ReactComponent };